"use client";

import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { Maybe, SVariantDto } from "@/__generated__/sdk";

type Props = {
  off?: boolean;
  variant?: Maybe<SVariantDto>;
};

const roundToHundred = (value: number): number => {
  return Math.round(value / 100) * 100;
};

function ProductCardSnappPayIcon({ off = false, variant }: Props) {
  const variantPrice = variant?.price;
  const offerPrice = variant?.offer?.price;
  const price = offerPrice ?? variantPrice ?? null;
  const installmentPrice = price ? roundToHundred(price / 4) : null;

  return (
    <Box
      sx={{
        zIndex: 1,
        display: "flex", // Take full width
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        p: 0.6,
        borderBottomRightRadius: (t) => t.spacing(1.5), // soft, subtle rounding
        borderBottomLeftRadius: (t) => t.spacing(1.5), // soft, subtle rounding
        color: off ? "grey.400" : "#0066cc",
        backgroundColor: off ? "grey.100" : "#d4ecff",
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      {installmentPrice ? (
        <Typography
          variant="body2"
          component="span"
          sx={{
            fontSize: { xs: 11, sm: 11.5 },
          }}
        >
          <strong>خرید اعتباری</strong>: <strong>4</strong> قسط <strong>{installmentPrice.toLocaleString("fa-IR")}</strong> تومانی
        </Typography>
      ) : (
        <Typography
          variant="body2"
          component="span"
          sx={{
            fontSize: { xs: 11, sm: 11.5 },
          }}
        >
          خرید اعتباری
        </Typography>
      )}
    </Box>
  );
}

export default memo(ProductCardSnappPayIcon);
